var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Magnifier / 24 / Outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.7094 20.29L17.9994 16.61C19.4395 14.8144 20.1369 12.5353 19.9482 10.2413C19.7595 7.9473 18.6991 5.81278 16.9849 4.27664C15.2708 2.7405 13.0332 1.91951 10.7323 1.98247C8.43145 2.04543 6.24214 2.98756 4.61456 4.61514C2.98698 6.24272 2.04485 8.43203 1.98189 10.7329C1.91893 13.0338 2.73992 15.2714 4.27606 16.9855C5.8122 18.6997 7.94672 19.7601 10.2407 19.9488C12.5347 20.1375 14.8138 19.4401 16.6094 18L20.2894 21.68C20.3824 21.7737 20.493 21.8481 20.6148 21.8989C20.7367 21.9497 20.8674 21.9758 20.9994 21.9758C21.1314 21.9758 21.2621 21.9497 21.384 21.8989C21.5059 21.8481 21.6165 21.7737 21.7094 21.68C21.8897 21.4935 21.9904 21.2443 21.9904 20.985C21.9904 20.7257 21.8897 20.4765 21.7094 20.29ZM10.9994 18C9.61495 18 8.26157 17.5895 7.11042 16.8203C5.95928 16.0511 5.06207 14.9579 4.53226 13.6788C4.00245 12.3997 3.86382 10.9922 4.13392 9.63436C4.40402 8.2765 5.0707 7.02922 6.04967 6.05025C7.02864 5.07128 8.27592 4.4046 9.63378 4.1345C10.9917 3.8644 12.3991 4.00303 13.6782 4.53284C14.9573 5.06265 16.0505 5.95986 16.8197 7.111C17.5889 8.26215 17.9994 9.61553 17.9994 11C17.9994 12.8565 17.2619 14.637 15.9492 15.9497C14.6364 17.2625 12.8559 18 10.9994 18Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fe0d636dcdd53249c87f0e2996a9d85e.svg";
export { ForwardRef as ReactComponent };